export {default as userLogo} from './User-white.png';
export {default as helpLogo} from './Help-white.png';
export {default as companyLogo} from './procomp.svg';
export {default as addLogo} from './Add-white.png';
export { default as addBlueLogo } from "./add-logo-blue.svg";
export {default as folderLogo} from './Folder-white.png';
export {default as lookupLogo} from './magnifying-glass.png';
export {default as reportsLogo} from './sheet-box.png';
export {default as aboutLogo} from './Help.png';
export {default as visionLogo} from './Vision-blue.png';
export {default as uploadLogo} from './Upload-blue.png';
export {default as disketteLogo} from './Diskette-blue.png';
export {default as clipboardLogo} from './Clipboard.png';
export {default as documentLogo} from './Text-documents.png';
export {default as arrowIcon} from './arrow.svg';
export {default as pagesLogo} from './pages.svg';
export {default as chevronBlueLogo} from './chevron-blue.svg';
export {default as chevronWhiteLogo} from './chevron-white.svg';
export {default as chevronBlueRightLogo} from './chevron-blue-right.svg';
export {default as threedotsLogo} from './threedots.svg';
export {default as signOffLogo} from './Signoff-white.png';
export {default as signOffRedLogo} from './Signoff@2x.png';
export {default as switchLogo} from './Switch-white.png';
export {default as tickLogo} from './Checkmark-white.png';
export {default as checkLogo} from './Checkmark-white-circle.png';
export {default as checkmarkLogo} from './Checkmark-circle.svg';
export {default as accountSample} from './Account-sample.png';
export {default as warningLogo} from './Warning-white.png';
export {default as warningRedLogo} from './Warning-red.png';
export {default as flagLogo} from './Flag-white.png';
export {default as inforceAbout} from './About_ProCompPPR.png';
export {default as newbizAbout} from './About_ProCompIllustration.png';
export {default as hourGlass} from './hourglass.svg';
export {default as helpLogoQuestion} from './help_outline-blue-18dp.svg';
export {default as eAppPlaceholder} from './eAppPlaceholder.svg';
export {default as deleteLogo} from './Trash.svg';
export {default as previewLogo} from './Zoom.svg';
export {default as closeIcon} from './Close.svg';
export {default as bankInfoLogo} from './Bank Info Illustration.svg';
export {default as dogOnBedLogo} from './Dog on bed.svg';
export {default as whiteboardPlantsLogo} from './Whiteboard with plants.svg';
export {default as clockLogo} from './Clock.svg';
export {default as documentReportLogo} from './document-report.svg';
export {default as procompBlueLogo} from './Procomp-logo-blue.png';
export {default as plantBookLogo} from './Plant-book.png';
export {default as scenarioWindowLogo} from './Scenario-window.png';
export {default as calculatorLogo} from './calculator.svg';
export {default as printLogo} from './icon-print.svg';
export {default as saveLogo} from './icon-save.svg';
export {default as IllustrationMagic} from './Illustration-Magic.svg';
export {default as IllustrationDino} from './illustration-dino.png';
export { default as ProcompLogoReverse } from "./Logo_Blue_Reverse.svg";
export { default as fullScreen } from "./fullScreen.png";
export { default as dragIcon } from "./drag-icon.svg";

